import { useSegmentTimeOnTaskQuery as useQuery } from '../schema'

export const useSegmentTimeOnTaskQuery: typeof useQuery = opts =>
  useQuery({
    fetchPolicy: 'cache-and-network',
    ...opts,
  })
